var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shift-header mb-4"},[_c('p',{staticClass:"mb-0 font-weight-medium"},[_vm._v(_vm._s(_vm.getShiftName(_vm.shift)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }